
  <!--Date of Life Event-->
<mat-form-field appearance="outline" class="event-date">
  <mat-label>{{ componentDisplayAttributes.formControlAttributes.label || 'Date of Life Event'}}</mat-label>
  <!-- @TODO Add constraints & messaging to detail the windows of validity -->
  <input matInput [matDatepicker]="picker1" [formControlName]="componentDisplayAttributes.formControlAttributes.formControlName" placeholder="MM/DD/YYYY" (dateChange)="dateChanged('change', $event); onDateSelected($event.value)">
  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
  <mat-datepicker #picker1></mat-datepicker>
  @if (dateFormControls[componentDisplayAttributes.formControlAttributes.formControlName].errors?.required) {
    <mat-error>{{ componentDisplayAttributes.custom?.dateOfLifeEventRequiredErrorMessage ? componentDisplayAttributes.custom?.dateOfLifeEventRequiredErrorMessage : 'Required'}}</mat-error>
  } 
  @if (dateFormControls[componentDisplayAttributes.formControlAttributes?.formControlName].errors?.firstOfMonth) {
    <mat-error>{{ componentDisplayAttributes.custom?.firstOfMonthErrorMessage ? componentDisplayAttributes.custom?.firstOfMonthErrorMessage : "Dates must be the first of the month." }}</mat-error>
  }
  @if (dateFormControls[componentDisplayAttributes.formControlAttributes.formControlName].errors?.outOfRange) {
    <mat-error>{{ componentDisplayAttributes.custom?.dateOfLifeEventRangeErrorMessage ? componentDisplayAttributes.custom?.dateOfLifeEventRangeErrorMessage : 'Date is out of range.'}}</mat-error>
  } 
</mat-form-field>
